var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "scratch" },
    [
      _c("Header"),
      _vm._v(" "),
      _c("iframe", {
        attrs: {
          id: "myiframe",
          src: _vm.ifreamSrc,
          scrolling: "no",
          width: "100%",
          frameborder: "0",
        },
        on: { load: _vm.changeFrameHeight },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/views/scratch/scratch.vue?vue&type=template&id=0b32c18a&
// module id = null
// module chunks = 